import { render } from "./tableControl.vue?vue&type=template&id=57075159&scoped=true"
import script from "./tableControl.vue?vue&type=script&lang=js"
export * from "./tableControl.vue?vue&type=script&lang=js"

import "./tableControl.vue?vue&type=style&index=0&id=57075159&scoped=true&lang=css"
import "./tableControl.vue?vue&type=style&index=1&id=57075159&lang=css"

import exportComponent from "E:\\Work\\GPTWeb\\licCode\\lic\\webviewer\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57075159"]])

export default __exports__